/**
 * Optimized image with WebP + JPEG fallback.
 * Hero images should pass eager + high priority.
 */
export default function OptimizedImage({
  src,
  alt = '',
  width,
  height,
  className,
  eager = false,
  sizes,
}) {
  const webpSrc = src.replace(/\.(jpe?g|png)$/i, '.webp');
  const hasWebp = /\.(jpe?g|png)$/i.test(src);
  const loading = eager ? 'eager' : 'lazy';
  const fetchPriority = eager ? 'high' : 'auto';

  if (!hasWebp) {
    return (
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={className}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        sizes={sizes}
      />
    );
  }

  return (
    <picture className={className}>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        sizes={sizes}
      />
    </picture>
  );
}
